<template>
  <div class="page-wrapper">
    <div class="card">

      <h2 class="page-title">👤 Master Customer</h2>

      <!-- FORM ROW 1 -->
        <div class="form-grid">

  <!-- Nama -->
  <input v-model="form.billing_name" class="input" placeholder="Nama Billing" />
  <input v-model="form.billing_phone" class="input" placeholder="No HP Billing" />

  <!-- Receiver -->
  <input v-model="form.receiver_name" class="input" placeholder="Nama Penerima (opsional)" />
  <input v-model="form.receiver_phone" class="input" placeholder="No HP Penerima (opsional)" />

  <!-- Address FULL -->
  <textarea
    v-model="form.address"
    class="input textarea-full"
    placeholder="Alamat lengkap"
  ></textarea>

  <!-- Delivery -->
  <select v-model="form.delivery_method_id" class="select-input">
    <option :value="null">-- Delivery Default (None) --</option>
    <option v-for="d in deliveryMethods" :key="d.id" :value="d.id">
      {{ d.name }}
    </option>
  </select>

  <!-- Pool -->
  <select v-model="form.poll_id" class="select-input">
    <option :value="null">-- Pool Default (None) --</option>
    <option v-for="p in polls" :key="p.id" :value="p.id">
      {{ p.name }}
    </option>
  </select>

</div>



      <button @click="saveCustomer" class="btn-primary">
        {{ form.id ? "Update" : "Simpan" }}
      </button>

      <hr class="my-4" />

      <!-- SEARCH -->
      <input
        v-model="search"
        placeholder="🔍 Cari customer..."
        class="input search"
      />

      <!-- TABLE -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>No HP</th>
              <th>Alamat</th>
              <th class="right">Aksi</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="c in filteredCustomers" :key="c.id">
              <td>{{ c.billing_name }}</td>
              <td>{{ c.billing_phone }}</td>
              <td>{{ c.address }}</td>

              <td class="right">
                <button class="btn-link edit" @click="editCustomer(c)">
                  Edit
                </button>
                <button class="btn-link danger" @click="deleteCustomer(c)">
                  Hapus
                </button>
              </td>
            </tr>

            <tr v-if="filteredCustomers.length === 0">
              <td colspan="4" class="empty">Customer tidak ditemukan</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "CustomersMaster",

  data() {
    return {
        customers: [],
        deliveryMethods: [],
        polls: [],
         search: "",
        form: {
            id: null,
            billing_name: "",
            billing_phone: "",
            receiver_name: "",
            receiver_phone: "",
            address: "",

            // ✅ OPTIONAL DEFAULTS
            delivery_method_id: null,
            poll_id: null
        }
    };
  },
  mounted() {
  this.fetchCustomers();
  this.fetchDeliveryMethods();
  this.fetchPolls();
},


  computed: {
    filteredCustomers() {
    const q = (this.search || "").toLowerCase();

    return this.customers.filter(c => {
      const name  = (c.billing_name || "").toLowerCase();
      const phone = (c.billing_phone || "").toLowerCase();
      const addr  = (c.address || "").toLowerCase();

      return (
        name.includes(q) ||
        phone.includes(q) ||
        addr.includes(q)
      );
    });
  }
  },

  methods: {
    async fetchDeliveryMethods() {
  const res = await fetch("/api/delivery_methods/get_delivery_methods.php");
  const json = await res.json();
  this.deliveryMethods = json.data || [];
},

async fetchPolls() {
  const res = await fetch("/api/polls/get_polls.php");
  const json = await res.json();
  this.polls = json.data || [];
},

    async fetchCustomers() {
      const res = await fetch("/api/customer/list.php");
      const json = await res.json();
      this.customers = json.data || [];
    },

    editCustomer(c) {
      this.form = { ...c };
    },

    async saveCustomer() {
  // ============================
  // VALIDATION
  // ============================
  if (!this.form.billing_name.trim()) {
    Swal.fire("Error", "Nama billing wajib diisi", "error");
    return;
  }

  if (!this.form.billing_phone.trim()) {
    Swal.fire("Error", "No HP billing wajib diisi", "error");
    return;
  }

  if (!this.form.address.trim()) {
    Swal.fire("Error", "Alamat wajib diisi", "error");
    return;
  }

  // ============================
  // FIX OPTIONAL NULL PAYLOAD
  // ============================
  const payload = {
    ...this.form,

    // ✅ Delivery optional → null kalau kosong
    delivery_method_id:
      this.form.delivery_method_id
        ? Number(this.form.delivery_method_id)
        : null,

    // ✅ Poll optional → null kalau kosong
    poll_id:
      this.form.poll_id
        ? Number(this.form.poll_id)
        : null
  };

  // ============================
  // API URL (CREATE / UPDATE)
  // ============================
  const url = this.form.id
    ? "/api/customer/update.php"
    : "/api/customer/save_customer.php";

  try {
    // ============================
    // REQUEST
    // ============================
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const json = await res.json();

    // ============================
    // ERROR RESPONSE
    // ============================
    if (!json.success) {
      Swal.fire("Gagal", json.message || "Terjadi error", "error");
      return;
    }

    // ============================
    // SUCCESS NOTIFICATION
    // ============================
    Swal.fire({
      icon: "success",
      title: this.form.id
        ? "Customer berhasil diupdate"
        : "Customer berhasil disimpan",
      timer: 1200,
      showConfirmButton: false
    });

    // ============================
    // RESET + RELOAD
    // ============================
    this.resetForm();
    this.fetchCustomers();

  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Server tidak merespon", "error");
  }
},


    async deleteCustomer(c) {
      if (!confirm(`Hapus customer "${c.billing_name}"?`)) return;

      await fetch("/api/customer/delete.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: c.id })
      });

      this.fetchCustomers();
    },

    resetForm() {
        this.form = {
            id: null,
            billing_name: "",
            billing_phone: "",
            receiver_name: "",
            receiver_phone: "",
            address: "",

            delivery_method_id: null,
            poll_id: null
        };
        }
  }
};
</script>
<style scoped>
.page-wrapper {
  padding: 24px;
  max-width: 1200px;
  margin: auto;
}

.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* FORM */
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.input {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  width: 100%;
  background: #fff;
}

textarea.input {
  resize: vertical;
  min-height: 70px;
}

.input.search {
  max-width: 320px;
  margin-bottom: 14px;
}

/* BUTTON */
.btn-primary {
  background: #3b82f6;
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  font-weight: 600;
  border: none;
  white-space: nowrap;
  cursor: pointer;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-link {
  font-weight: 500;
  margin-left: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.btn-link.edit {
  color: #2563eb;
}

.btn-link.danger {
  color: #dc2626;
}

/* TABLE */
.table-wrapper {
  border-top: 1px solid #eee;
  margin-top: 12px;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  text-align: left;
  padding: 14px 10px;
  font-size: 14px;
  color: #555;
  white-space: nowrap;
}

tbody td {
  padding: 14px 10px;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
  vertical-align: top;
}

.right {
  text-align: right;
  white-space: nowrap;
}

.empty {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
}

/* RESPONSIVE */
@media (max-width: 640px) {
  .form-row {
    flex-direction: column;
  }

  .input.search {
    max-width: 100%;
  }
}
/* 2 kolom sejajar */
.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* Responsive: mobile jadi 1 kolom */
@media (max-width: 640px) {
  .two-col {
    grid-template-columns: 1fr;
  }
}
/* ============================= */
/* FORM GRID */
/* ============================= */

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 14px;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

/* ============================= */
/* TEXTAREA FULL */
/* ============================= */

.textarea-full {
  grid-column: span 2;
}

@media (max-width: 768px) {
  .textarea-full {
    grid-column: span 1;
  }
}

/* ============================= */
/* DROPDOWN MASTER */
/* ============================= */

.select-input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  background: #fff;
  transition: 0.2s;
}

.select-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

</style>